/** Los chips de estado de una campaña y de una persona (el color nunca va solo: siempre con el texto). */

import type { EstadoCampana, EstadoPersona } from "../types";
import { MANDO_A_TODOS, TEXTO_ESTADO_CAMPANA, TEXTO_ESTADO_PERSONA } from "../logic/emails";

const CLS = "inline-flex items-center text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 rounded-full whitespace-nowrap";

/**
 * Snov deja «activa» una campaña que ya le mandó el último paso a todos (espera respuestas): con `faltan` en 0 dice
 * «Mandó a todos» y no «Enviando», que hacía creer que seguía saliendo.
 */
export function ChipEstadoCampana({ estado, faltan }: { estado: EstadoCampana; faltan?: number | null }) {
  const termino = estado === "activa" && faltan === 0;
  const e = termino ? MANDO_A_TODOS : TEXTO_ESTADO_CAMPANA[estado] || TEXTO_ESTADO_CAMPANA.otro;
  return (
    <span className={`${CLS} ${e.cls}`} title={termino ? "En Snov sigue activa: ya le mandó a todos y espera respuestas." : undefined}>
      {e.texto}
    </span>
  );
}

export function ChipEstadoPersona({ estado }: { estado: EstadoPersona }) {
  const e = TEXTO_ESTADO_PERSONA[estado] || TEXTO_ESTADO_PERSONA.entregado;
  return <span className={`${CLS} ${e.cls}`}>{e.texto}</span>;
}
